var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDoubleCheckWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 2.96368,
  y: 11.4551,
  width: 10.8799,
  height: 1.5009,
  transform: "rotate(-51 2.96368 11.4551)",
  fill: "#FFFFFF"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 4.12354,
  y: 12.3936,
  width: 5.306,
  height: 1.5,
  transform: "rotate(-141 4.12354 12.3936)",
  fill: "#FFFFFF"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 7.48041,
  y: 11.4551,
  width: 10.8799,
  height: 1.5009,
  transform: "rotate(-51 7.48041 11.4551)",
  fill: "#FFFFFF"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 8.64026,
  y: 12.3936,
  width: 2.74671,
  height: 1.5,
  transform: "rotate(-141 8.64026 12.3936)",
  fill: "#FFFFFF"
})));
export { SvgDoubleCheckWhite as ReactComponent };
export default __webpack_public_path__ + "cdde304075c8750b58852c3986569669.svg";